import { useTranslation } from "react-i18next";
import CommonModal from "PhishingManager/components/Modal";
import { ModalProps } from "PhishingManager/components/Modal/Modal.types";

const FirstWhitelistingModal = ({
    open,
    onClose,
    onConfirm
}: ModalProps) => {
    const { t } = useTranslation();

    return (
        <CommonModal
            visible={open}
            confirmText={t("phishingManager.firstWhitelistingModal.confirmText")}
            cancelText={t("phishingManager.firstWhitelistingModal.cancelText")}
            iconType={null}
            modalTitle={t("phishingManager.firstWhitelistingModal.title")}
            modalContentDesc={[
                t("phishingManager.firstWhitelistingModal.description.line1"),
                t("phishingManager.firstWhitelistingModal.description.line2"),
                t("phishingManager.firstWhitelistingModal.description.line3")
            ]}
            onClose={onClose}
            onConfirm={onConfirm}
        />
    );
};

export default FirstWhitelistingModal;